import cn from 'clsx'

import { ImageBox } from 'shared-components'

import s from './Hero.module.sass'

function Hero({ project }: any) {
    const { title, client, featuredImage, projectCategories } = project

    const _projectCategories = projectCategories
        ? projectCategories.map((category: any) => category?.name).join(', ')
        : null

    return (
        <section className={s.Hero}>
            <div className={s.Main}>
                <div className={cn(s.Cont, 'container')}>
                    {title && (
                        <h2
                            dangerouslySetInnerHTML={{
                                __html: title,
                            }}
                        />
                    )}
                    <div className={s.Details}>
                        {client && (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: client,
                                }}
                                data-title="Client"
                            />
                        )}
                        {_projectCategories && (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: _projectCategories,
                                }}
                                data-title="Industry"
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className={s.Image}>{featuredImage && <ImageBox image={featuredImage} priority />}</div>
        </section>
    )
}

export default Hero
